import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=2fb5d0ac&scoped=true&lang=pug"
var script = {}
import style0 from "./Privacy.sass?vue&type=style&index=0&id=2fb5d0ac&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5d0ac",
  null
  
)

export default component.exports